var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.LazyProductList.Messages.GetLazyProductList, Vendd.LazyProductList, function (envelope) {
        
        var options = {
            url: 'LazyProductListService.svc/GetLazyProductList' + envelope.message.data.url,
            method: 'GET',
            data: envelope.message.data.serviceConfiguration,
            onSuccess: onSuccess,
            onFailure: onFailure
        };
        
        if (envelope.message.data.serviceConfiguration.allowLazyloadCdnCaching) {
            options.servicenamespace = 'cachedservices'
        }

        function onSuccess(response) {
            
            if (response && !response.d) { 
                var model = response;
                Vendd.MessageBus.publishAsync(Vendd.LazyProductList, new Vendd.LazyProductList.Messages.LazyProductListSuccess(model, envelope.sender));
            }

            Vendd.MessageBus.publishAsync(Vendd.LazyProductList, new Vendd.LazyProductList.Messages.LazyProductListFailure());
        };
            
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.LazyProductList, new Vendd.LazyProductList.Messages.LazyProductListFailure(response, envelope.sender));
        };

        Vendd.Service.call(options);

        return;

    });

    return Vendd;

})(Vendd || {});